<template>

    <select-org
      :label="label"
      type="Authority"
      v-model="formData"
      :required="required"
      :placeholder="placeholder"
      :help-text="helpText"
      :size="size"
      :disabled="disabled"
      :no-form="noForm"
      :full-object="fullObject"
      @change="updated"
      is-admin
      />

</template>

<script>

import SiteMixins from '@/mixins/SiteMixins'
import SelectOrg from '@/components/atoms/selects/SelectOrg'

export default {
  name: 'select-authority',

  mixins: [SiteMixins],

  components: {
    SelectOrg
  },

  props: {

    label: {
      type: String,
      default: 'Authority'
    },

    value: {
      required: true
    },

    size: {
      type: String,
      default: 'default'
    },

    disabled: {
      type: Boolean,
      default: false
    },

    required: {
      type: Boolean,
      default: false
    },

    placeholder: {
      type: String,
      default: 'Authorities (min 3 letters)'
    },

    helpText: {
      type: String,
      default: null
    },

    callback: {
      type: Function,
      default: null
    },

    fullObject: {
      type: Boolean,
      default: false
    },

    noForm: {
      type: Boolean,
      default: false
    }

  },



  methods: {

    updated (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }

  },


  data () {
    return {
      formData: this.value
    }
  }

}
</script>



// WEBPACK FOOTER //
// SelectAuthority.vue?040c6024